module.exports = __webpack_public_path__ + "static/media/service_coach.0bd9cbd1.png";